window.locale = $('html').attr('lang');

/**
 * Scroll To Top
 */
window.scrollToTop = function () {
    $("html, body").animate({ scrollTop: 0 }, "fast");
}

/**
 * Scroll to selector element on DOM
 *
 * @param   {selector}  selector    The selector where scroll to
 */
window.slideToElement = function (selector = null) {
    // Get the element
    const element = document.querySelector(selector);
    // Get the focus out
    $(this).blur();
    // Check if the element is height is not defined
    if (!element || !element.offsetTop) {
        // Cut the execution
        return;
    }
    // Go to the top
    $("html, body").animate({ scrollTop: element.offsetTop }, "fast");
    return false;
};

/**
 * Gets the current parameter value from url
 * 
 * @param   {string}    The parameter name
 * @param   {string}    The parameter default value if not exist on url
 *
 * @return  {string}    The current parameter value
 */
window.getCurrentParam = function (paramName, defaultValue) {
    let newValue = defaultValue;
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has(paramName)) {
        newValue = searchParams.get(paramName);
    }
    return newValue;
}

/**
 * Sets the current parameter value to url
 *
 * @param   {string}    The parameter name
 * @param   {string}    The parameter value to set on url
 */
window.setCurrentParameter = function (paramName, newValue) {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(paramName, newValue);
    history.replaceState({}, "", `?${searchParams.toString()}`);
}

$(function () {
    //Función Button Scroll/Slide To Top
    $(window).on("scroll", function () {
        if ($(window).scrollTop() >= 150) {
            if (!$("#slideToTop").is(":visible")) {
                $("#slideToTop").fadeIn(500);
            }
        } else {
            $("#slideToTop").fadeOut(500);
        }
    });
});
